// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// import MiniLayout from "../ResuableCompoment/MiniLayout";

// const PrivateRoute = ({ element: Component, withLayout = false, ...rest}) => {
//   const token = useSelector((state) => state.auth.employeeDetails?.token);

//   // useEffect(() => {
//   //   let timer;
//   //   const resetTimer = () => {
//   //     clearTimeout(timer);
//   //     timer = setTimeout(() => {
//   //       dispatch(logout());
//   //     }, 30000);
//   //   };

//   //   window.addEventListener("mousemove", resetTimer);
//   //   window.addEventListener("keydown", resetTimer);
//   //   window.addEventListener("keyup", resetTimer);
//   //   window.addEventListener("scroll", resetTimer);
//   //   window.addEventListener("touchstart", resetTimer);

//   //   resetTimer();

//   //   return () => {
//   //     clearTimeout(timer);
//   //     window.removeEventListener("mousemove", resetTimer);
//   //     window.removeEventListener("keydown", resetTimer);
//   //     window.addEventListener("keyup", resetTimer);
//   //     window.removeEventListener("scroll", resetTimer);
//   //     window.removeEventListener("touchstart", resetTimer);
//   //   };
//   // }, [dispatch]);
//   

//   if (!token) {
//      // Debug logging
//     return <Navigate to="/" replace />;
//   }

//   return withLayout && (
//     <MiniLayout>
//       <Component {...rest} />
//     </MiniLayout>
//   )
// };

// export default PrivateRoute;







import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { startSessionHeartbeat, stopSessionHeartbeat } from "../CustomHooks/sessionHeartbeat";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector(
    (state) => !!state.auth.employeeDetails?.token
  );

  useEffect(() => {
    if (isAuthenticated) {
      startSessionHeartbeat();
      return () => stopSessionHeartbeat();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
